let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g8xuM")).then(() => parcelRequire('esCFD'));